import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import store from "./store";
import VueRouter from 'vue-router'
import axios from 'axios';
import Element from 'element-ui';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import CrFactoryModule from './factory/module/CrFactoryModule.js'
import ComponentsMoudel from './factory/components/'
import RouteConfig from './components/config/RouterConfig.js'
import HttpConfig from './components/config/HttpConfig.js'
import Print from 'vue-print-nb'
import VueParticles from 'vue-particles'
import {EventEmitter} from 'events';
import dataV from '@jiaminghi/data-view';
import {getUserInfo} from "@/api/api";
import  '@/filters/index'

//背景动效
Vue.use(VueParticles)
//  地图组件
import D3Config from '../src/utils/D3Config'

import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import echarts from 'echarts';
import './dash/icons'

// 防止路由跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  // debugger
  return originalPush.call(this, location).catch(err => err)
}
import {reqGet,reqPost,reqPut,reqDel,transformDateFormat} from "@/assets/js/interface_back";
// axios.defaults.baseURL = "http://106.14.82.40:8082";
Vue.prototype.axios = axios;

Vue.prototype.reqGet = reqGet;//封装get请求
Vue.prototype.reqPost = reqPost;//封装post请求
Vue.prototype.reqPut = reqPut;//封装put请求
Vue.prototype.reqDel = reqDel;//封装delete请求

Vue.use(mavonEditor);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(Element);
Vue.use(ViewUI);
Vue.use(ComponentsMoudel);
Vue.use(Print);
Vue.use(dataV);

Vue.use(ViewUI, {
  model: {
    zIndex: 500
  }
});
//事件中心
window.EventCenter=new EventEmitter();
Vue.prototype.EventCenter = new EventEmitter();
CrFactoryModule.instance.configRouter(RouteConfig);
CrFactoryModule.instance.configHttp(HttpConfig);
let router = CrFactoryModule.instance.routerConfig;
let hostname=window.location.hostname;
const configuredHost = window.appConfig && window.appConfig.ROOT;
const defaultHost = `${window.location.protocol}//${hostname === 'localhost' || hostname === '127.0.0.1' ? '127.0.0.1' : hostname}:8081`;

Vue.prototype.baseURL = "/"
Vue.prototype.host = (configuredHost || defaultHost).replace(/\/$/, '')
Vue.prototype.$echarts = echarts

Vue.filter('timeFilter', function(time) {
  if(!time) {
    return ''
  }else{
    return time.split(' ')[0]
  }
})


//  地图全局挂载
Vue.prototype.D3Config=D3Config

// getToken().then(function(res){
//   console.log("登陆",res.data.msg);
//   localStorage.setItem("token", res.data.msg);
// })
Vue.config.productionTip = false

import 'cesium/Build/Cesium/Widgets/widgets.css';
import * as Cesium from 'cesium';
window.Cesium=Cesium;
var vue = new Vue({
	router,
  store,
	render: h => h(App),
}).$mount('#app')
export default vue;
